import { useSelector } from "react-redux";

import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box } from "@mui/material";

export function InsertLineItem(props) {
  const { onClick } = props;
  const linesLoading = useSelector((state) => state.loading.linesLoading);

  return (
    <Box
      sx={{
        position: "absolute",
        right: "100%",
        bottom: "calc(100% - 0.9rem)",
        width: "1.3em",
        cursor: linesLoading ? "not-allowed" : "pointer",
        zIndex: "insertLine",
        opacity: linesLoading ? 0.5 : 1,
      }}
      onClick={linesLoading ? undefined : onClick}
      data-testing="insertLineItem"
      title="Insert line"
    >
      <ArrowForward sx={{ color: linesLoading ? "text.disabled" : "icons" }} />
    </Box>
  );
}
